/**
 * DevExtreme (esm/__internal/core/utils/m_console.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { isFunction } from "../../../core/utils/type";
const noop = function () {};
const getConsoleMethod = function (method) {
  if ("undefined" === typeof console || !isFunction(console[method])) {
    return noop;
  }
  return console[method].bind(console);
};
export const logger = {
  log: getConsoleMethod("log"),
  info: getConsoleMethod("info"),
  warn: getConsoleMethod("warn"),
  error: getConsoleMethod("error")
};
export const debug = function () {
  function assert(condition, message) {
    if (!condition) {
      throw new Error(message);
    }
  }
  return {
    assert: assert,
    assertParam: function (parameter, message) {
      assert(null !== parameter && void 0 !== parameter, message);
    }
  };
}();
export default {
  logger: logger,
  debug: debug
};